import { toUberPosKey } from './uberPosKey.js';
/**
 * The stable per-entity key every consumer matching an Owner entity back to a POS
 * entity must derive here — reconciliation, saved presentation order and order
 * injection all key on it, and a derivation that disagrees resolves to nothing
 * rather than erroring.
 *
 * Single-id POSes key on that id. An Uber entity maps to one Owner record per menu
 * and per parent context, so `uber.id` alone is ambiguous and the composite key
 * stands in for it.
 */
export const toPosEntityKey = (pos) => {
    const native = pos?.otter?.id ?? pos?.clover?.id;
    if (native != null)
        return native;
    const uber = pos?.uber;
    if (!uber?.menuId || !uber.id)
        return null;
    return toUberPosKey({
        menuId: uber.menuId,
        id: uber.id,
        contextId: uber.contextId,
    });
};
/**
 * The POS's own id for the entity. Not the match key where one POS entity maps to
 * several Owner records: an Uber entity's records share a native id while their
 * keys differ, which is how "same entity, different record" is told apart from
 * "the POS replaced this entity's id".
 */
export const toNativePosId = (pos) => pos?.otter?.id ?? pos?.clover?.id ?? pos?.uber?.id ?? null;
//# sourceMappingURL=posEntityKey.js.map